const VaultOnboardingMessages = {
  HasBwInstalled: "hasBwInstalled",
  checkBwInstalled: "checkIfBWExtensionInstalled",
} as const;

export { VaultOnboardingMessages };
